import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(formData, 'agent');

      if (result.success) {
        // Small delay to ensure state is fully updated
        setTimeout(() => {
          navigate('/agent/dashboard');
        }, 100);
      }
    } catch (error) {
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-16 px-4" style={{ background: 'linear-gradient(135deg, #EDE9FE 0%, #F5F3FF 50%, #EDE9FE 100%)' }}>
      {/* Background dots */}
      <div className="fixed inset-0 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle, #C4B5FD 1.2px, transparent 1.2px)', backgroundSize: '28px 28px', opacity: 0.4 }} />
      <div className="fixed top-0 right-0 pointer-events-none" style={{ width: '400px', height: '400px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(167,139,250,0.35) 0%, transparent 70%)', transform: 'translate(30%,-30%)' }} />

      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src={`${process.env.PUBLIC_URL}/ticketaty-logo.svg`}
            alt="Ticketaty"
            className="h-10 w-auto mx-auto mb-2"
          />
          <p className="text-purple-600 font-medium mt-1">Sign in to scan and validate tickets</p>
        </div>

        <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(16px)', border: '1px solid rgba(196,181,253,0.4)', boxShadow: '0 8px 40px rgba(139,92,246,0.15)' }}>
          <div className="p-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Email Address</label>
                <input
                  type="email" name="email" autoComplete="email" required
                  placeholder="agent@example.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl text-sm text-gray-900 outline-none transition-all"
                  style={{ background: '#F5F3FF', border: '1.5px solid #DDD6FE' }}
                  onFocus={e => e.target.style.borderColor = '#8B5CF6'}
                  onBlur={e => e.target.style.borderColor = '#DDD6FE'}
                />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1.5">Password</label>
                <input
                  type="password" name="password" autoComplete="current-password" required
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="w-full px-4 py-3 rounded-xl text-sm text-gray-900 outline-none transition-all"
                  style={{ background: '#F5F3FF', border: '1.5px solid #DDD6FE' }}
                  onFocus={e => e.target.style.borderColor = '#8B5CF6'}
                  onBlur={e => e.target.style.borderColor = '#DDD6FE'}
                />
              </div>
              <button type="submit" disabled={loading} className="w-full py-3 rounded-xl font-bold text-white text-sm transition-all hover:scale-[1.02] disabled:opacity-60" style={{ background: 'linear-gradient(135deg, #8B5CF6, #7C3AED)', boxShadow: '0 6px 20px rgba(139,92,246,0.35)' }}>
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Signing in...
                  </span>
                ) : 'Sign In as Agent'}
              </button>
            </form>
            <div className="mt-5 text-center">
              <Link to="/" className="block text-sm text-gray-500 hover:text-gray-700 transition-colors nav-link">← Back to Home</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
